const FALLBACK_ACCENT_RGB = "255, 2, 199";
const DEFAULT_PRIMARY = "#4200ff";
const DEFAULT_SECONDARY = "#ff02c7";
const DEFAULT_PINK = "#de03b9";

export const EVENT_THEME_VARIABLES = ["--primary", "--secondary", "--gradient", "--pink", "--accent-rgb"];

const normalizeHexColor = (value) => {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  const shortHexMatch = trimmed.match(/^#([a-fA-F0-9]{3})$/);
  if (shortHexMatch) {
    const [r, g, b] = shortHexMatch[1].split("");
    return `#${r}${r}${g}${g}${b}${b}`;
  }
  const longHexMatch = trimmed.match(/^#([a-fA-F0-9]{6})$/);
  if (longHexMatch) return trimmed;
  return null;
};

export const colorToRgbTriplet = (colorValue, fallback = FALLBACK_ACCENT_RGB) => {
  const normalizedHex = normalizeHexColor(colorValue);
  if (normalizedHex) {
    const hex = normalizedHex.slice(1);
    const red = parseInt(hex.slice(0, 2), 16);
    const green = parseInt(hex.slice(2, 4), 16);
    const blue = parseInt(hex.slice(4, 6), 16);
    return `${red}, ${green}, ${blue}`;
  }

  if (typeof colorValue === "string") {
    const rgbMatch = colorValue.match(
      /^\s*rgba?\(\s*([01]?\d?\d|2[0-4]\d|25[0-5])\s*,\s*([01]?\d?\d|2[0-4]\d|25[0-5])\s*,\s*([01]?\d?\d|2[0-4]\d|25[0-5])/i,
    );
    if (rgbMatch) {
      return `${rgbMatch[1]}, ${rgbMatch[2]}, ${rgbMatch[3]}`;
    }
  }

  return fallback;
};

export const getEventThemeVars = (event) => {
  const primary = event?.mainColor1 || DEFAULT_PRIMARY;
  const secondary = event?.mainColor2 || DEFAULT_SECONDARY;
  const accent = event?.mainColor1 || event?.mainColor2 || DEFAULT_PINK;

  return {
    "--primary": primary,
    "--secondary": secondary,
    "--gradient": "linear-gradient(91.24deg, var(--primary) 0.26%, var(--secondary) 99.58%)",
    "--pink": accent,
    "--accent-rgb": colorToRgbTriplet(accent),
  };
};

export const applyThemeVarsToElement = (element, vars = {}) => {
  if (!element) return;
  EVENT_THEME_VARIABLES.forEach((variableName) => {
    const value = vars?.[variableName];
    if (value !== undefined && value !== null && value !== "") {
      element.style.setProperty(variableName, value);
    }
  });
};

export const clearThemeVarsFromElement = (element) => {
  if (!element) return;
  EVENT_THEME_VARIABLES.forEach((variableName) => {
    element.style.removeProperty(variableName);
  });
};
